import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m14.421 9.079-.32-.642c-.394-.787-.496-.961-.617-1.08a1.25 1.25 0 0 0-.467-.288c-.16-.056-.362-.069-1.242-.069h-4.55c-.88 0-1.082.013-1.242.069a1.25 1.25 0 0 0-.467.288c-.121.119-.223.293-.617 1.08L3.62 11h1.29c.893 0 1.71.504 2.108 1.303.06.12.184.197.32.197h4.323a.36.36 0 0 0 .242-.095l1.415 1.414a2.36 2.36 0 0 1-1.658.681H7.34a2.36 2.36 0 0 1-2.108-1.303.36.36 0 0 0-.32-.197H3v1.4c0 .647 0 1.072.027 1.397.026.313.07.444.11.52.12.236.31.427.546.547.076.039.207.083.52.109.326.026.75.027 1.397.027h7.8c.647 0 1.071 0 1.396-.027.314-.026.445-.07.522-.11.225-.114.41-.294.53-.515l1.437 1.437a3.25 3.25 0 0 1-1.06.861c-.405.206-.829.284-1.266.32-.416.034-.923.034-1.52.034H5.561c-.597 0-1.104 0-1.52-.034-.437-.036-.861-.114-1.266-.32a3.25 3.25 0 0 1-1.42-1.42c-.207-.405-.285-.83-.321-1.267C1 15.543 1 15.036 1 14.44V12.8c0-.267 0-.492.031-.718q.042-.3.139-.586a5 5 0 0 1 .293-.657L3.17 7.424c.301-.605.554-1.111.947-1.496a3.25 3.25 0 0 1 1.214-.75c.52-.18 1.085-.179 1.761-.178h4.816c.676 0 1.242-.001 1.761.178.456.157.87.413 1.214.75.393.385.646.891.947 1.496l.082.164z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22.954 11.563a1.02 1.02 0 0 0-.45-.556l-.18-.106-.371-.01-4.841-.01L18.8 9.183s.696-.715.753-.888a.98.98 0 0 0-.441-1.191c-.153-.09-.225-.106-.475-.105-.208 0-.334.022-.431.073-.188.098-4.194 4.096-4.326 4.318-.09.149-.105.222-.105.47 0 .25.015.322.105.471.132.222 4.138 4.22 4.326 4.319.097.05.223.072.431.072.25.001.322-.015.475-.105a.98.98 0 0 0 .44-1.19c-.056-.173-.752-.89-.752-.89l-1.688-1.695 4.84-.01.371-.01.18-.107a.985.985 0 0 0 .45-1.153",
      clipRule: "evenodd"
    }
  )
);
var SvgInboxArrowInOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var InboxArrowInOutlined_default = SvgInboxArrowInOutlined;

export { InboxArrowInOutlined_default as default };
